module.exports = __webpack_public_path__ + "static/media/Logo_Standby_Small.6eb97509.png";